import _ from 'underscore';
import getConfig from 'next/config';

import filesHelpers from '@culture/utils/helpers/files';
import entitiesHelpers from '@culture/utils/helpers/entities';

const { publicRuntimeConfig } = getConfig();

const urlsHash = {
	broadcast: 'broadcast',
	streamingPlatforms: 'streaming-platform',
	movies: 'movies'
};

export const getImageUrl = (file, options = {}) =>
	filesHelpers.getImageUrl(file, { config: publicRuntimeConfig, ...options });

export const patchImageUrl = (file, options = {}) =>
	filesHelpers.patchImageUrl(file, { config: publicRuntimeConfig, ...options });

export const getEntityUrl = (entityType, entity, options = {}) => {
	const prefix = urlsHash[entityType];

	if (prefix) {
		const urlParts = [prefix, entity._id, entity.name];

		return `/${_(urlParts).compact().join('/')}`;
	}

	return entitiesHelpers.getEntityUrl(entityType, entity, {
		config: publicRuntimeConfig,
		...options
	});
};
